module.exports = "pegasus/assets/mountains-nature-sky-sunny.png";